module.exports = __webpack_public_path__ + "img/blockChainLoading.b8e9632b.png";